var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PersistentNotificationBase',{attrs:{"notification":_vm.notification,"containerClass":_vm.containerClass},on:{"hide":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }